import { Progress } from "../departmentProgress/utils";

export type ProgressOverride = {
  value: string | undefined;
  onChange: (progress: Progress) => void;
  isSaving: boolean;
};

type ProgressEntity = { progress?: object };

/**
 * The admin progress override in the lifecycle dialogs: writes one lifecycle's progress onto the
 * stored entity and nothing else, so unsaved edits in the dialog are neither sent nor lost.
 *
 * Progress only, never the lifecycle's `complete` flag: the worker emails a lifecycle's assignees
 * when that flag flips false to true, and an override is a correction, not the department finishing.
 * Same rule as the warehouse sync (`syncedCreditRiskProgress` in warehouseSync/applyPatch.ts).
 */
export const buildProgressOverride = <TEntity extends ProgressEntity>(
  entity: TEntity,
  progressKey: keyof NonNullable<TEntity["progress"]> & string,
  update: { mutate: (entity: TEntity) => void; isPending: boolean }
): ProgressOverride => ({
  value: (entity.progress as Record<string, string | undefined> | undefined)?.[
    progressKey
  ],
  onChange: (progress) =>
    update.mutate({
      ...entity,
      progress: { ...entity.progress, [progressKey]: progress }
    }),
  isSaving: update.isPending
});
